import { GetterTree } from 'vuex';

// Store's root state
import { RootState } from '@/store/store.types';

// Section getters
import { Getters as CompanyGetters } from '@/store/sections/company/company.getters';
import { Getters as ProductsGetters } from '@/store/sections/products/products.getters';
import { Getters as RequestGetters } from '@/store/sections/request/request.getters';
import { Getters as SpacesGetters } from '@/store/sections/spaces/spaces.getters';
import { Getters as SystemGetters } from '@/store/sections/systems/systems.getters';

/**
 *  Holding every getter of the store.
 */
export const getters: GetterTree<RootState, RootState> = {

    /**
     *  Every section's getters.
     */
    ...CompanyGetters,
    ...ProductsGetters,
    ...RequestGetters,
    ...SpacesGetters,
    ...SystemGetters,

};
